import axios from "axios";
import store from '@/store/index'
import { getToken, refreshTokenCookie } from '@/utils/auth'
import { tansParams } from '@/utils/nangzhong'
import cache from '@/plugins/cache'
import errorCode from '@/utils/errorCode'
import { MessageBox } from 'element-ui';
import {
    AESDecrypt
} from '@/utils/aes/encryption-utils.js';

// 是否显示重新登陆
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const instance = axios.create({
    timeout: 10000
});

instance.interceptors.request.use(
    config => {
        // 是否需要设置 token
        const skipToken = (config.headers || {}).isToken == false
        // 是否需要防止数据重复提交
        const isRepeatSubmit = (config.headers || {}).repeatSubmit == false
        const token = getToken()
        if (token && !skipToken) {
            config.headers['Authorization'] = 'Bearer ' + token;
            // 仅保存在本次 Axios 请求配置中，用于隔离旧请求返回的 401。
            config.__requestAuthToken = token;
        }
        if(config.baseURL) {
            axios.baseURL = config.baseURL
        }
        let dataType = store.state.user.dataType
        // get请求映射params参数
        if (config.method === 'get' || config.method === 'delete') {
            if(!config.params) {
                config.params = {};
            }
            if(config.params.dataType === null) {
                delete config.params.dataType;
            } if(!config.params.dataType) {
                config.params.dataType = dataType;
            }
            let url = config.url + '?' + tansParams(config.params);
            url = url.slice(0, -1);
            config.params = {};
            config.url = url;
        }
        if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
            if(!config.data) {
                config.data = {};
            }
            if(config.data.dataType === null) {
                delete config.data.dataType;
            } else if(!config.data.dataType) {
                config.data.dataType = dataType;
            }
            const requestObj = {
                url: config.url,
                data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
                time: new Date().getTime()
            }
            const requestSize = Object.keys(JSON.stringify(requestObj)).length;
            const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
            if (requestSize >= limitSize) {
                console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
                return config;
            }
            const sessionObj = cache.session.getJSON('sessionObj')
            if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
                cache.session.setJSON('sessionObj', requestObj)
            } else {
                const s_url = sessionObj.url;                  // 请求地址
                const s_data = sessionObj.data;                // 请求数据
                const s_time = sessionObj.time;                // 请求时间
                const interval = 1000;
                // 间隔时间(ms)，小于此时间视为重复提交  
                if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
                    const message = '数据正在处理，请勿重复提交';
                    console.warn(`[${s_url}]: ` + message)
                    return Promise.reject(new Error(message));
                } else {
                    cache.session.setJSON('sessionObj', requestObj);
                }
            }
        }
        return config;
    },
    error => {
        console.log(error);
        Promise.reject(error);
    }
)

// 响应拦截器处理函数
function responseInterceptor(res) {
    if(typeof res.data === "string") {
        res.data = AESDecrypt(res.data);
    } 
    return res;
}

function authenticationError(message) {
    const error = new Error(message)
    error.code = 401
    return error
}

instance.interceptors.response.use(
    res => {
        res = responseInterceptor(res);
        // 未设置状态码则默认成功状态
        const code = res.data.code || 200;
        // 获取错误信息
        const msg = errorCode[code] || res.data.msg || errorCode['default']
        const requestToken = res.config && res.config.__requestAuthToken
        // 二进制数据则直接返回
        if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
            return res.data
        }
        if (code === 200 && requestToken) {
            // Cookie 与服务端滑动会话同步续期；旧请求不能给已替换的 token 续期。
            refreshTokenCookie(requestToken)
        }
        if (code === 401) {
            const currentToken = getToken()
            // 公开接口或旧会话请求的 401 不得影响当前已经更新的登录态。
            if (!requestToken || currentToken !== requestToken) {
                return Promise.reject(new Error('旧会话请求已失效，当前登录状态不受影响。'))
            }
            if (!isRelogin.show) {
                isRelogin.show = true;
                MessageBox.confirm(
                    '登录状态已过期，请重新登录',
                    '系统提示',
                    {
                        confirmButtonText: '重新登录',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).then(() => {
                    // 弹窗期间可能已经完成新登录，确认时再次校验失败会话。
                    if (getToken() !== requestToken) {
                        return false
                    }
                    return store.dispatch('user/LogOut', { expectedToken: requestToken }).then(loggedOut => {
                        if (loggedOut) {
                            location.href = '/login/code';
                        }
                        return loggedOut
                    })
                }).catch(() => {
                    // 用户选择暂不重新登录，后续受保护请求仍可再次提示。
                }).finally(() => {
                    isRelogin.show = false;
                });
            }
            return Promise.reject(authenticationError('无效的会话，或者会话已过期，请重新登录。'))
        } else if (code === 500) {
            return Promise.reject(msg)
        } else if (code === 601) {
            return Promise.reject('error')
        } else if (code !== 200) {
            return Promise.reject('error')
        } else {
            return res.data;
        }
    },
    error => {
        let { message } = error;
        if (message.includes("Network Error")) {
            message = "后端接口连接异常";
        } else if (message.includes("timeout")) {
            message = "系统接口请求超时";
        } else if (message.includes("Request failed with status code")) {
            message = "系统接口" + message.substr(message.length - 3) + "异常";
        }
        return Promise.reject(message)
    }
)

export default instance;
